<template>
  <div class="quick-add-box">
    <div class="add-control" v-loading="submitLoading" element-loading-background="rgba(0, 0, 0, 0)" @click="doSubmit" :style="{ left: mouseX + 'px', top: mouseY + 'px' }">
      <div class="desc">
        <div>操作说明：</div>
        <div>1.点击鼠标快速生成点位</div>
        <div>2.键盘Esc退出快速标点模式</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mouseX: 0,
      mouseY: 0,
      submitLoading: false,
      vForm: {
        id: '',
        works_id: '',
        material_id: '',
        name: '',
        title: '',
        is_show_title: 1,
        type: 0,
        ath: 0,
        atv: 0,
        width: 30,
        height: 30,
        thumb: '',
        thumb_name: '',
        thumb_preview: '',
        is_distorted: 2, //图标是否扭曲
        is_zoom: 2, //图标是否缩放
        ext: {
          switch_type: '',
          material_id: '',
          work_type: 1,
          work: { id: '', name: '', url: '' },
          scene_open_type: 1,
        },
      },
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'materialId', 'worksId']),
  },

  created() {
    this.vForm.works_id = this.worksId;
    this.vForm.material_id = this.materialId;

    this.handleMouseMove();
    this.handleKeyEsc();
    this.inteXY();
  },

  methods: {
    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    //初始化位置
    inteXY() {
      let btn = document.getElementById('quickAddHostspotBtn');
      this.mouseX = btn.offsetLeft + btn.clientWidth / 2;
      this.mouseY = btn.offsetTop + btn.clientHeight / 2;
    },

    //鼠标移动
    handleMouseMove() {
      document.body.addEventListener('mousemove', (e) => {
        if (this.submitLoading) {
          return;
        }
        this.mouseX = e.pageX;
        this.mouseY = e.pageY;
      });
    },

    //键盘点击ESC
    handleKeyEsc() {
      if (this.submitLoading) {
        return;
      }
      document.body.addEventListener('keydown', (e) => {
        if (e.keyCode == 27) {
          if (this.submitLoading) {
            return;
          }
          this.$emit('update:show', false);
        }
      });
    },

    async doSubmit(e) {
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      try {
        this.krp.call(`set(x,${e.pageX})`);
        this.krp.call(`set(y,${e.pageY})`);
        this.krp.call(`screentosphere(x,y,ath,atv)`);
        this.vForm.ath = this.krp.get('ath');
        this.vForm.atv = this.krp.get('atv');
        this.vForm.name = `hotspot_${this.utils.UUID.generate()}`;
        let list = await this.api.spot.lists({
          works_id: this.worksId,
          material_id: this.materialId,
        });
        let listType = list.data.filter((item) => item.type == 0);
        let index = listType.length ? Number(listType[0].title.split('-')[0]) + 1 : 1;
        this.vForm.title = `${index}-待完善`;
        let res = await this.api.spot.add(this.vForm);
        this.$message.success(`添加成功`);
        this.vForm.id = res.data.id;
        this.toAddSpot();
        await this.actionGetSceneDetail({ worksId: this.worksId, materialId: this.materialId });
      } catch (e) {
        console.error(e);
      }
      this.submitLoading = false;
    },

    toAddSpot() {
      this.addHotspot();
      this.addHotspotEdit();
      this.addHotspotDelete();
      this.addHotspotTitle();
    },

    addHotspot() {
      let name = this.vForm.name;
      this.krp.call(`addhotspot(${name})`);
      this.krp.call(`set(hotspot[${name}].url,'/krpano/images/preview/hotspot.png')`);
      this.krp.call(`set(hotspot[${name}].ath,${this.vForm.ath})`);
      this.krp.call(`set(hotspot[${name}].atv,${this.vForm.atv})`);
      this.krp.call(`set(hotspot[${name}].zoom,${this.vForm.is_zoom == 1})`);
      this.krp.call(`set(hotspot[${name}].distorted,${this.vForm.is_distorted == 1})`);
      this.krp.call(`set(hotspot[${name}].width,${this.vForm.width})`);
      this.krp.call(`set(hotspot[${name}].height,${this.vForm.height})`);
      this.krp.call(`set(hotspot[${name}].ondown,draghotspot(${this.vForm.id}))`);
      this.krp.call(`set(hotspot[${name}].onover,overspot(${name}))`);
      this.krp.call(`set(hotspot[${name}].onout,outspot(${name}))`);
    },

    addHotspotEdit() {
      let name = this.vForm.name;
      this.krp.call(`addlayer(${name}_edit)`);
      this.krp.call(`set(layer[${name}_edit].html,编辑)`);
      this.krp.call(`set(layer[${name}_edit].type,text)`);
      this.krp.call(`set(layer[${name}_edit].align,righttop)`);
      this.krp.call(`set(layer[${name}_edit].visible,false)`);
      this.krp.call(`set(layer[${name}_edit].x,-36)`);
      this.krp.call(`layer[${name}_edit].loadstyle(hotspot_label_style)`);
      this.krp.call(`set(layer[${name}_edit].parent,hotspot[${name}])`);
      this.krp.call(`set(layer[${name}_edit].onclick,js(krpjs.editHotSpot(${this.vForm.id})))`);
    },

    addHotspotDelete() {
      let name = this.vForm.name;
      this.krp.call(`addlayer(${name}_delete)`);
      this.krp.call(`set(layer[${name}_delete].html,删除)`);
      this.krp.call(`set(layer[${name}_delete].type,text)`);
      this.krp.call(`set(layer[${name}_delete].align,righttop)`);
      this.krp.call(`set(layer[${name}_delete].visible,false)`);
      this.krp.call(`set(layer[${name}_delete].x,-36)`);
      this.krp.call(`set(layer[${name}_delete].y,20)`);
      this.krp.call(`layer[${name}_delete].loadstyle(hotspot_label_style)`);
      this.krp.call(`set(layer[${name}_delete].parent,hotspot[${name}])`);
      this.krp.call(`set(layer[${name}_delete].onclick,js(krpjs.deleteHotSpot(${this.vForm.id},${this.vForm.name})))`);
    },

    addHotspotTitle() {
      let name = this.vForm.name;
      this.krp.call(`addlayer(${name}_title)`);
      this.krp.call(`set(layer[${name}_title].html,${this.vForm.title})`);
      this.krp.call(`set(layer[${name}_title].type,text)`);
      this.krp.call(`set(layer[${name}_title].visible,${this.vForm.is_show_title == 1})`);
      this.krp.call(`set(layer[${name}_title].align,top)`);
      this.krp.call(`set(layer[${name}_title].y,-25)`);
      this.krp.call(`layer[${name}_title].loadstyle(hotspot_label_style)`);
      this.krp.call(`set(layer[${name}_title].parent,hotspot[${name}])`);
    },
  },
};
</script>

<style scoped>
.quick-add-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.add-control {
  position: absolute;
  width: 100px;
  height: 130px;
  box-shadow: 0 0 0 200vw rgba(0, 0, 0, 0.5);
  z-index: 101;
  transform: translate(-50%, -50%);
  cursor: crosshair;
}

.add-control .desc {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 10px);
  background: #fff;
  width: 200px;
  padding: 10px;
  font-size: 12px;
  border-radius: 4px;
  user-select: none;
  animation: fadeOut 1s ease 5s;
  animation-fill-mode: forwards;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
